import { render, staticRenderFns } from "./SmallCarouselSlider.vue?vue&type=template&id=66f84597&scoped=true"
import script from "./SmallCarouselSlider.vue?vue&type=script&lang=js"
export * from "./SmallCarouselSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f84597",
  null
  
)

export default component.exports